module.exports = __webpack_public_path__ + "img/Electrico.c46832a2.png";